"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestRackPowerCommandValidation = void 0;
class TestRackPowerCommandValidation {
    static isValid(entity) {
        // Validate entity.enable for existence and correct type.
        if (entity.enable == undefined)
            return false;
        if (typeof entity.enable !== "boolean")
            return false;
        // Validate entity.desired_voltage_v for existence and correct type.
        if (entity.desired_voltage_v == undefined)
            return false;
        if (typeof entity.desired_voltage_v !== "number")
            return false;
        // Validate entity.desired_current_a for existence and correct type.
        if (entity.desired_current_a == undefined)
            return false;
        if (typeof entity.desired_current_a !== "number")
            return false;
        // Validate entity.expected_max_voltage_v for existence and correct type.
        if (entity.expected_max_voltage_v == undefined)
            return false;
        if (typeof entity.expected_max_voltage_v !== "number")
            return false;
        return true;
    }
}
exports.TestRackPowerCommandValidation = TestRackPowerCommandValidation;
